import {
  IsString, IsNotEmpty, IsOptional, ValidateIf, Matches,
  MinLength, Min, Max,
} from 'class-validator';

export class EditGroupCombinedDTO {
  @IsString()
  @IsNotEmpty({ message: 'Name required' })
  @Matches(/^[A-Za-z0-9_ ]{0,20}$/,
    { message: 'Wrong name format' })
  public name: string | undefined;

  @IsString()
  @IsNotEmpty({ message: 'Code required' })
  @Matches(/^[A-Za-z0-9_]{0,20}$/,
    { message: 'Wrong code format' })
  public code: string | undefined;

  @IsOptional()
  public group_id?: number | string | null | undefined;

  @IsNotEmpty({ message: 'Longitude required' })
  @Min(-180, { message: 'Longitude must be >= -180' })
  @Max(180, { message: 'Longitude must be <= 180' })
  public longitude: number | undefined;

  @IsNotEmpty({ message: 'Latitude required' })
  @Min(-90, { message: 'Latitude must be >= -90' })
  @Max(90, { message: 'Latitude must be <= 90' })
  public latitude: number | undefined;

  @IsOptional()
  public elevation?: number | undefined;

  @IsOptional()
  public azimuth?: number | undefined;

  @IsNotEmpty()
  @MinLength(1, { message: 'Units required' })
  public units: string | undefined;

  @IsOptional()
  public mapOrigin_id?: number | undefined;

  @IsOptional()
  public xofffset?: number | undefined;

  @IsOptional()
  public yoffset?: number | undefined;

  @IsOptional()
  public theta?: number | undefined;

  @ValidateIf((o) => (!!o.imageimage || !!o.imagePresent))
  @IsNotEmpty({ message: 'Pixels per length required' })
  public pixelsPerLength?: number | undefined;

  @IsOptional()
  public imageimage?: string | undefined | null;

  @IsOptional()
  public imagePresent?: string | undefined | null;
}
